import { RoleType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';

import { Field } from '../../../forms/createAdminForm';

import { ContainerStyled } from './FormContent.styles';

export const FormContent = () => {
  const { t } = useTranslation();

  // remove super-admin role
  const roles = Object.values(RoleType).filter(
    (v) => v !== RoleType.Superadmin && v !== RoleType.Admin
  );
  return (
    <ContainerStyled>
      <Field.Text
        showRequiredMark
        autoComplete="off"
        label={t('admin.fields.email.label')}
        name="email"
        placeholder={t('admin.fields.email.placeholder')}
      />

      <Field.Text
        showRequiredMark
        label={t('admin.fields.lastName.label')}
        name="lastName"
        placeholder={t('admin.fields.lastName.placeholder')}
      />

      <Field.Text
        showRequiredMark
        label={t('admin.fields.firstName.label')}
        name="firstName"
        placeholder={t('admin.fields.firstName.placeholder')}
      />

      <Field.Text
        label={t('admin.fields.middleName.label')}
        name="middleName"
        placeholder={t('admin.fields.middleName.placeholder')}
      />

      <Field.Autocomplete
        hideClearIcon
        showRequiredMark
        label={t('admin.fields.role.label')}
        name="role"
        optionLabelKey="label"
        options={roles.map((v) => ({
          label: t(`admin.adminRoles.${v}`),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t('admin.fields.role.placeholder')}
        variant="select"
      />

      <Field.Text
        label={t('admin.fields.position.label')}
        name="position"
        placeholder={t('admin.fields.position.placeholder')}
      />
    </ContainerStyled>
  );
};
